import { PaginationData } from '@/shared/dto';

export const TABLE_PAGINATION_LIMIT = 5;

export enum TrustedSourceType {
  DOMAIN = 'DOMAIN',
  EMAIL = 'EMAIL',
}

export const trustedSourceTypeTitles: Record<TrustedSourceType, string> = {
  [TrustedSourceType.DOMAIN]: 'Domain',
  [TrustedSourceType.EMAIL]: 'Email',
};

export type TrustedSource = {
  key: string;
  id: string;
  type: TrustedSourceType;
  value: string;
  comment?: string;
  expiredAt?: number;
  lastValidatedAt?: number;
  createdAt: number;
  updatedAt: number;
};

export type TrustedSourceStore = {
  items: TrustedSource[];
  isLoading: boolean;
  currentPage: number;
  currentLimit: number;
  searchColumn: string;
  searchValue?: string;
  pagination?: PaginationData;
  getItems: () => void;
  setCurrentPage: (value: number) => void;
  setSearchValue: (value: string) => void;
};
